import * as React from "react";
import "./TwoColumnPage.scss";
import {ScreenSize} from "../../ScreenSize/ScreenSize";
import MediaQuery from "react-responsive";

export interface ITwoColumnPageProps {
  left: JSX.Element,
  right: JSX.Element
}

const TwoColumnPage: React.SFC<ITwoColumnPageProps> = ({left, right}) =>
  <div className="nzpost-js-tool-two-col-page">
    <div className="nzpost-js-tool-two-col-page-left">
      {left}
    </div>
    <MediaQuery minWidth={ScreenSize.Desktop}>
      <div className="nzpost-js-tool-two-col-page-right">
        {right}
      </div>
    </MediaQuery>
  </div>
;

export default TwoColumnPage;



// WEBPACK FOOTER //
// ./src/components/lib/Pages/TwoColumnPage/TwoColumnPage.tsx